<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
           <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleAddFooterSocial" class="ml-auto">
                    <span class="color-white">
                        add footer Social
                    </span>
                </el-button>
            </div>
            <el-card class="box-card">
                <el-table :data="footerSocials" style="width: 100%">
                    
                    
                    <el-table-column label="image" prop="iconURL" width="80" >
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.iconURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.iconURL)]"
                                :preview-teleported="true"
                                class="bg-theme"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="site URL" prop="siteURL" />
                  
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-popconfirm 
                                title="Are you sure to delete this?"
                                @confirm="deleteSocial(scope.row)"
                            >
                                <template #reference>
                                   <font-awesome-icon :icon="['fas', 'trash']" style="width:20px" class="cursor-pointer color-red" />
                                </template>
                            </el-popconfirm>
                            
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
export default {
    computed:{
        cachedFooterSocials(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.footer?.footerSocials?.list || []
        },
    },
    data(){
        return{
            footerSocials:[],
            footerSocialStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedFooterSocials?.length){
            this.getFooterSocial();
        }else{
            this.footerSocials = this.cachedFooterSocials;
          
        }
        
       
    },
    
    methods:{
       
        async getFooterSocial(){
            const response = await this.$store.dispatch('getFooterSocial');
            this.footerSocials = response;
             
        },
        
        async deleteSocial(socialData){
            
            let dataToSend = {
                id:socialData.id
            }
            const response = await this.$store.dispatch('deleteSocial',dataToSend);
            if (response.data.status == 1){
                this.getFooterSocial();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
            }
            
        },
        async handleAddFooterSocial(){
            this.$router.push({
                name:'manage-footer-social'
            })
        },
        async handleEditFooterSocial(footerSocial){
            await this.$store.dispatch('storeCurrentFooterSocialToView',footerSocial)
            this.$router.push({
                name:'manage-footer-social',
                params:{
                    id:footerSocial.id
                }
            })
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>